import ListRelated from './list-related'

export default ListRelated
